// PreliminaryEstimate
export const QUOTE = 'Quote';
export const PREPAID = 'Prepaid Items';